import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { validators } from "./Validators";
import Transition from "./Transition";
import LenderResultRowDetailV2 from "./LenderResultRowDetailV2";

class LenderResultRowV2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            offsetWidth : 0,
            isDetailExpanded: false,
             mpUniqueClickID: this.getGUID()
        }
        // this.state = {  };
        this.handleOfferDetailToggle = this.handleOfferDetailToggle.bind(this);
        this.handleTransitionClick = this.handleTransitionClick.bind(this);
    }
    // updateDimensions = () => {
    //     var width = document.getElementById('acorn-body');
    //     this.setState({ deviceWidth: width.offsetWidth });   
    // };
    // componentDidMount() {
    //     var width = document.getElementById('acorn-body');
    //     var that = this;
    //     window.addEventListener("resize", (ev) => {
    //         var width = document.getElementById('acorn-body');
    //         that.setState({ deviceWidth : width.offsetWidth});
    //     });
    // }
    // componentWillUnmount() {
    //     window.removeEventListener('resize', this.updateDimensions);
    // }

    handleOfferDetailToggle(event) {
        this.setState((prevState) => ({
            isDetailExpanded: !prevState.isDetailExpanded
        }));
    }

    componentDidUpdate() {
        // Hiding offer detail on update result clicked if it was opened previously
        if (this.props.isLoading && this.state.isDetailExpanded) {
            this.setState({ isDetailExpanded: false });
        }
    }

    handleTransitionClick(event) {
        event.preventDefault();

        ReactDOM.render(<Transition lenderName={this.props.lender.lender}
            redirectTo={event.target.href}
            lenderLogo={this.props.lender.lender_image.source_medium} />,
            document.getElementById('root'));
    }

    parseQueryString = (url) => {
        var urlParams = {};
        url.replace(
            new RegExp("([^?=&]+)(=([^&]*))?", "g"),
            function ($0, $1, $2, $3) {
                urlParams[$1] = $3;
            }
        );
        return urlParams.CID;
    }
    FindTerms(term) {
       if(term !== undefined) {
        var newTerm = term.split(",");
        var min, max =0;
        if(newTerm.length > 0) {
            min = parseInt(newTerm[0], 10) * 12;
        }
        if(newTerm.length > 1) {
            max = parseInt(newTerm[newTerm.length -1 ], 10) * 12;
        }
        return `${min} - ${max} Months`;
    }
    return '';
    }
    getGUID() {
        var prGUID = "", i, random;
        for (i = 0; i < 32; i++) {
       random = Math.random() * 16 | 0;
    
       if (i === 8 || i === 12 || i === 16 || i === 20) {
        prGUID += "-"
       }
       prGUID += (i === 12 ? 4 : (i === 16 ? ((random & 3) | 8) : random)).toString(16);
        }
        return prGUID;
      }
    Submit(e){
        if(window._paq) {
            window._paq.push(['setCustomDimension', window.customDimensionId = 2, window.customDimensionValue = this.props.lender.lender]);
            window._paq.push(['setCustomDimension', window.customDimensionId = 3, window.customDimensionValue = this.state.mpUniqueClickID]);
            window._paq.push(['setCustomDimension', window.customDimensionId = 8, window.customDimensionValue = this.state.mpUniqueClickID]);
            window._paq.push(['setCustomDimension', window.customDimensionId = 9, window.customDimensionValue = this.props.loanAmount]);
            window._paq.push(['setCustomDimension', window.customDimensionId = 10, window.customDimensionValue = this.props.indexCount]);
            window._paq.push(['setCustomDimension', window.customDimensionId = 11, window.customDimensionValue = this.props.creditScore]);
            window._paq.push(['setCustomDimension', window.customDimensionId = 12, window.customDimensionValue = this.props.annualIncome]);
            window._paq.push(['setCustomDimension', window.customDimensionId = 16, window.customDimensionValue = this.props.SortVersion]);
            window._paq.push(['trackEvent','PLMP','PLMP Offer Click', this.props.lender.lenderId]);
            var that = this;
            setTimeout(function () {
                that.setState({ mpUniqueClickID: that.getGUID()});
            }, 1000);
        }       
    }
    GenerateApplyLink() {
        let lenderApplyLink = `${window.applicationURL}`;
        if(this.props.loanAmountBC) {
            lenderApplyLink = `${lenderApplyLink}&loanAmount=${this.props.loanAmountBC}`;
        }
        if(this.props.loanPurposeBC) {
            lenderApplyLink = `${lenderApplyLink}&loanPurpose=${this.props.loanPurposeBC}`;
        }
        if(this.props.gclid) {
            lenderApplyLink = `${lenderApplyLink}&gclid=${this.props.gclid}`;
        }
        if(this.props.programid) {
            lenderApplyLink = `${lenderApplyLink}&programid=${this.props.programid}`;
        }
        if(this.props.campaignid) {
            lenderApplyLink = `${lenderApplyLink}&campaignid=${this.props.campaignid}`;
        }
        if(this.props.utmSource) {
            lenderApplyLink = `${lenderApplyLink}&utm_source=${this.props.utmSource}`;
        }
        if(this.props.utmMedium) {
            lenderApplyLink = `${lenderApplyLink}&utm_medium=${this.props.utmMedium}`;
        }
        if(this.props.utmTerm) {
            lenderApplyLink = `${lenderApplyLink}&utm_term=${this.props.utmTerm}`;
        }
        if(this.props.utmCampaign) {
            lenderApplyLink = `${lenderApplyLink}&utm_campaign=${this.props.utmCampaign}`;
        }
        if(this.props.utmContent) {
            lenderApplyLink = `${lenderApplyLink}&utm_content=${this.props.utmContent}`;
        }
        if(this.props.version) {
            lenderApplyLink = `${lenderApplyLink}&version=${this.props.version}`;
        }
        if(this.props.dealerid || window[this.props.rootId].dealerId) {
            // Unset the previous link //
            let delearID=this.props.dealerid?this.props.dealerid:( window[this.props.rootId].dealerId?window[this.props.rootId].dealerId:'');
                lenderApplyLink = `${lenderApplyLink}?d=${delearID}`;
        }
        lenderApplyLink = lenderApplyLink.replace('[clickid]', this.state.mpUniqueClickID).replace('[affiliateid]',this.props.AffiliateId);
        return  lenderApplyLink;
    }
    render() {
        const lender = this.props.lender;
        const LenderDescriptinData='';
        const lenderPath = lender.lender_image.source_medium;
        const lenderLogo = `https://${window.cdn  !== undefined ? window.cdn : window.location.hostname}${lenderPath}`; //lender.lender_image.source_medium;
        const lenderLogoAltText = lender.lender;
        const minCreditScore = !this.props.IsPRLender ? lender.min_fico_score_text === null ? "None" : lender.min_fico_score_text : '';
        const ctaText =lender.apply.link_text ;       
        const lenderId =  lender.lenderId;
        const toggleOfferDetailLabel = this.state.isDetailExpanded ? 'Hide details' : 'View details';
        const rowClass = ''; // Removed active class for all row as per PM-708
        const applyLink = this.GenerateApplyLink();
        return (
            [ 
                <div className="lenderBlock">
                    <div className={`row mobilelenderContent ${this.props.deviceWidth > 1023 && !this.props.readOnly ? ' fiveblockcode ' : ''}` }>
                        {this.props.deviceWidth <= 767 ? 
                            <div className=" col-xs-6 lenderName" >{lender.lenderDisplay}</div>  
                        : '' }
                        <div className={`col-md-3 col-sm-${!this.props.readOnly ? '3' : '4'} col-xs-6 logoTop`} >
                            <img key={'li-a-img-' + lenderId} id={`id-image-${lenderId}`} name={`name-image-${lenderId}`} alt={lenderLogoAltText} src={lenderLogo} /> 
                            {this.props.deviceWidth >= 768 ?
                                <span className="show-details" key={'li-span-' + lender.lenderId}>
                                    <a key={'li-span-a-' + lender.lenderId} href={`#${lender.lenderId}`} onClick={this.handleOfferDetailToggle}>{toggleOfferDetailLabel}
                                        {this.state.isDetailExpanded ? 
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                <path d="M18 15l-6-6-6 6" />
                                            </svg>
                                                                                    
                                        : 
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                <path d="M6 9l6 6 6-6" />
                                            </svg>                                
                                        }
                                    </a>
                                </span>   
                            : ''}
                        </div>  
                        <div className={`col-md-3 col-sm-${!this.props.readOnly ? '3' : '4'} col-xs-6 nopadding`} >
                            <div className="lenderTextAlign" >
                                <div class='loandetailsvalue'><b> {lender.apr_text}</b></div>
                                <div class='loandetailstext'>APR</div>
                            </div>
                        </div>    
                        <div className={`col-md-3 col-sm-${!this.props.readOnly ? '3' : '4'} col-xs-6 nopadding`} >
                            <div className="lenderTextAlign" >
                                <div class='loandetailsvalue'> <b>{lender.term_years}</b></div>
                                <div class='loandetailstext'>LOAN TERM</div>
                            </div>    
                        </div>  
                        {this.props.deviceWidth > 1023 ? 
                            <div className="col-md-3 col-sm-3 col-xs-6" >
                                <div className="lenderTextAlign" >
                                    <div className="loandetailsvalue loanAmountVal"> 
                                        <b>Up to <span className="" >{lender.max_loan_amount_text}</span></b>
                                    </div> 
                                    <div className="loandetailstext">LOAN AMOUNT</div>
                                </div>
                            </div>  
                        : '' }
                       {this.props.deviceWidth <= 767 ? <div className="clearfix"></div> : ''}
                        { !this.props.readOnly ? 
                            <div className="col-md-3 col-sm-3 col-xs-12" >
                                <a href={applyLink} id={`checkOffersButton`} target="_blank" className={` checkOffersButton btn btn-primary`} >{ctaText}</a>
                            </div>  
                        : '' }
                        {this.props.deviceWidth <= 767 ?
                                <span className="show-details" key={'li-span-' + lender.lenderId}>
                                    <a key={'li-span-a-' + lender.lenderId} href={`#${lender.lenderId}`} onClick={this.handleOfferDetailToggle}>
                                        {toggleOfferDetailLabel}{this.state.isDetailExpanded ? 
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                <path d="M18 15l-6-6-6 6" />
                                            </svg> 
                                        : 
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                <path d="M6 9l6 6 6-6" />
                                            </svg>
                                        }
                                    </a>
                                </span>   
                            : ''}
                            

                    </div>    
                    <div className="clearfix"></div>
                    <div className="row ">
                        <div className="col-xs-12" >
                            <LenderResultRowDetailV2 key={'detail-' + lender.lenderId}
                                isDetailExpanded={this.state.isDetailExpanded}
                                lender={lender}
                                disclaimer={lender.disclaimer}
                                //lenderDescription={LenderDescriptinData}
                                offerDetail={lender.offers.offer_details.offer_details}
                                rowClass={rowClass}
                                onHideDetailClick={this.handleOfferDetailToggle}
                                toggleOfferDetailLabel={toggleOfferDetailLabel}
                                lenderId={lender.lenderId} />
                        </div>
                    </div>
                    {/* {this.props.deviceWidth >= 1024 ?
                    <div>
                     <ul className={`row`} id={lenderId} key={`ul-${lenderId+'-'+lenderId}-${this.props.indexCount}`}>
                        <div className="col-md-4">
                          <li className={`${this.props.IsPRLender ? ' pr-row-height ' : ' '} logopadding`} key={`li-${lenderId}`}>
                              <img key={'li-a-img-' + lenderId} id={`id-image-${lenderId}`} name={`name-image-${lenderId}`} alt={lenderLogoAltText} src={lenderLogo} />
                          </li>
                          <div className="moreDetails">
                              {!this.props.IsPRLender && 
                              <div className="showdisclosureContent"> 
                              <span className="show-details" key={'li-span-' + lender.lenderId}>
                                  <a key={'li-span-a-' + lender.lenderId} href={`#${lender.lenderId}`} onClick={this.handleOfferDetailToggle}>{toggleOfferDetailLabel}{this.state.isDetailExpanded ? <span> &#8722;</span> : <span> &#xf107;</span> }</a>
                              </span>
                              </div>
                              }
                          </div>
                          </div>

                          <li className={`${this.props.IsPRLender ? ' pr-row-height ' : ' '} loan-cellV2 lenderinfoV2 lender-desc col-md-2 `} >
                          <div className="" dangerouslySetInnerHTML={{ __html: `<div class='loandetailsvalue'><b> ${lender.apr_text}</b></div><div class='loandetailstext'>APR</div>` }}></div>
                          </li>
                          <li className={`${this.props.IsPRLender ? ' pr-row-height ' : ' '} loan-cellV2 lenderinfoV2 lender-desc col-md-2 `} >
                              <div className="" dangerouslySetInnerHTML={{ __html: `<div class='loandetailsvalue'> <b>${lender.term_years}</b></div><div class='loandetailstext'>LOAN TERM</div>` }}></div>
                          </li>
                          <li className={`${this.props.IsPRLender ? ' pr-row-height ' : ' '} loan-cellV2 lenderinfoV2 lender-desc col-sm-2 `} key={'li-bigtxt-' + lenderId+'-'+lenderId+'-'+this.props.indexCount}>
                              {!this.props.IsPRLender  ? <div>
                             <div className="loandetailsvalue"> <b>Up to <span className="" dangerouslySetInnerHTML={{ __html: `${lender.max_loan_amount_text}` }}></span></b></div> <div className="loandetailstext">LOAN AMOUNT</div>
                              </div> 
                              : <span>
                                  <b className="brand-color"> {lender.title}</b> <br />
                                  <p > {lender.description}</p>
                              </span>
                              }
                          </li>
                          <li className={`${this.props.IsPRLender ? ' pr-row-height ' : ' '} loan-cellV2 lenderinfoV2 lender-desc col-sm-2 `} key={'li-bigtxt-' + lenderId+'-'+lenderId}>
                            <button type="submit" id={`update-result-mobile`} name={`update-result-mobile`} className={` checkOffersButton`} >Check Offers</button>
                        </li>
                       
                         <li>
                              <LenderResultRowDetailV2 key={'detail-' + lender.lenderId}
                              isDetailExpanded={this.state.isDetailExpanded}
                              lender={lender}
                              disclaimer={lender.disclaimer}
                              //lenderDescription={LenderDescriptinData}
                              offerDetail={lender.offers.offer_details.offer_details}
                              rowClass={rowClass}
                              deviceWidth={this.props.deviceWidth}
                              onHideDetailClick={this.handleOfferDetailToggle}
                              toggleOfferDetailLabel={toggleOfferDetailLabel}
                              lenderId={lender.lenderId} />
                          </li> 

                      </ul> 
                            </div>
                      
                     :
                        <div>
                            <ul className={`row`} id={lenderId} key={`ul-${lenderId+'-'+lenderId}`}>
                            <div className="col-sm-4">
                                <li class="col-sm-3 noPaddingTabInfo">
                                    <div className={`${this.props.IsPRLender ? ' pr-row-height ' : ' '} loan-cellV2 col-md-2 `} key={`li-${lenderId}`}>
                                        <img key={'li-a-img-' + lenderId} id={`id-image-${lenderId}`} name={`name-image-${lenderId}`} alt={lenderLogoAltText} src={lenderLogo} />
                                    </div>
                                </li>
                                <div className="moreDetails col-sm-3">
                              {!this.props.IsPRLender && 
                              <div className="showdisclosureContent"> 
                              <span className="show-details" key={'li-span-' + lender.lenderId}>
                                  <a key={'li-span-a-' + lender.lenderId} href={`#${lender.lenderId}`} onClick={this.handleOfferDetailToggle}>{toggleOfferDetailLabel}{this.state.isDetailExpanded ? <span> &#8722;</span> : <span> &#43;</span> }</a>
                              </span>
                              </div>
                              }
                                </div>
                                </div>

                                <li className="col-sm-2 noPaddingTabInfo">
                                    <div className={`${this.props.IsPRLender ? ' pr-row-height ' : ' '} loan-cellV2 lenderinfoV2 lender-desc `} >
                                        <span className="" dangerouslySetInnerHTML={{ __html: `<div class='loandetailsvalue'><b> ${lender.apr_text}</b></div><div class='loandetailstext'>APR</div>` }}></span>
                                    </div>
                                </li>
                                <li className="col-sm-2 noPaddingTabInfo">
                                    <div className={`${this.props.IsPRLender ? ' pr-row-height ' : ' '} loan-cellV2 lenderinfoV2 lender-desc `} >
                                        <span className="" dangerouslySetInnerHTML={{ __html: `<div class='loandetailsvalue'><b>${lender.term_years}</b></div><div class='loandetailstext'>LOAN TERM</div>` }}></span>
                                    </div>
                                </li>                                  
                                <li className="showtoggle">
                                    <LenderResultRowDetailV2 key={'detail-' + lender.lenderId}
                                        isDetailExpanded={this.state.isDetailExpanded}
                                        lender={lender}
                                        disclaimer={lender.disclaimer}
                                        //lenderDescription={LenderDescriptinData}
                                        offerDetail={lender.offers.offer_details.offer_details}
                                        rowClass={rowClass}
                                        onHideDetailClick={this.handleOfferDetailToggle}
                                        toggleOfferDetailLabel={toggleOfferDetailLabel}
                                        lenderId={lender.lenderId} />
                                </li>
                                </ul>
                           </div>} */}
                </div> 
            ]
        );
    }
}

export default LenderResultRowV2;


// WEBPACK FOOTER //
// ./src/LenderResultRowV2.js